import * as React from "react";
import { View, TouchableOpacity, Text, Image, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import {
  colorAndShape,
  colors,
  formatMoney,
  radius,
  shadow,
} from "../../theme/modern";

const FOOTER = 62;

export default class EntryComponent extends React.PureComponent {
  onPress = () => {
    this.props.onPress(this.props.value);
  };

  onLongPress = () => {
    this.props.onLongPress(this.props.value);
  };

  // a photo when the item has one, its colour and shape otherwise
  renderMedia(height) {
    const { value } = this.props;
    const { color, shape } = colorAndShape(value);

    if (value.imagePath) {
      return (
        <Image
          resizeMode="cover"
          source={{ uri: value.imagePath }}
          style={[styles.media, { height, backgroundColor: "#e9edf3" }]}
        />
      );
    }
    return (
      <View style={[styles.media, styles.swatch, { height }]}>
        <View style={[styles.fill, { backgroundColor: color }]} />
        <Icon
          name={shape}
          style={[styles.shape, { fontSize: Math.round(height * 0.56) }]}
        />
      </View>
    );
  }

  render() {
    const { value, size, currency, isCurrencyDisabled } = this.props;
    const width = size ? size : 170;
    const compact = width < 140;
    const mediaHeight = Math.round(width * (compact ? 0.56 : 0.6));

    return (
      <TouchableOpacity
        activeOpacity={0.85}
        onPress={this.onPress}
        onLongPress={this.onLongPress}
        style={[
          styles.card,
          { width, height: mediaHeight + FOOTER },
          this.props.style,
        ]}
      >
        {this.renderMedia(mediaHeight)}
        <View style={styles.footer}>
          <Text
            numberOfLines={compact ? 2 : 1}
            style={[styles.name, compact ? styles.nameCompact : null]}
          >
            {this.props.useDescription ? value.description : value.name}
          </Text>
          {value.price ? (
            <Text style={styles.price}>
              {formatMoney(value.price, currency, isCurrencyDisabled)}
            </Text>
          ) : null}
        </View>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  card: {
    borderRadius: radius.large,
    backgroundColor: colors.surface,
    overflow: "hidden",
    ...shadow.card,
  },
  media: {
    width: "100%",
  },
  swatch: {
    alignItems: "center",
    justifyContent: "center",
  },
  fill: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.92,
  },
  shape: {
    color: "rgba(255, 255, 255, 0.85)",
  },
  footer: {
    height: FOOTER,
    paddingHorizontal: 12,
    justifyContent: "center",
  },
  name: {
    fontSize: 14,
    fontWeight: "700",
    color: colors.text,
  },
  nameCompact: {
    fontSize: 12,
    lineHeight: 15,
  },
  price: {
    marginTop: 3,
    fontSize: 14,
    fontWeight: "700",
    color: colors.primary,
  },
});
